import { en } from "./en"
import { ru } from "./ru"

const resources = {
    en,
    ru
};

export { resources };